import { ADDRESSPOPUP } from "../constants/ActionTypes"

const initialLocationsState = {
    GET_POPUP_PROVINCE_PROTOTYPE: null,
    OPEN_POPUP_STATUS: null,
    OPEN_POPUP:null,
    OPEN_ADDRESS_LIST: null 
    
}

export default function( state = initialLocationsState , action = {}){
    let GET_POPUP_PROVINCE_PROTOTYPE = action.GET_POPUP_PROVINCE_PROTOTYPE;
    let OPEN_POPUP = action.OPEN_POPUP;


    switch( action.type ){ 
        case ADDRESSPOPUP.OPEN_ADDRESS_LIST:
            return Object.assign({},state,{
                OPEN_ADDRESS_LIST: 1,
                OPEN_POPUP_STATUS: 1
            })
            break;
        case ADDRESSPOPUP.CLOSE_POPUP:
            return Object.assign({},state,{
                OPEN_POPUP: null,
                OPEN_ADDRESS_LIST: null,
                OPEN_POPUP_STATUS: null
            })
            break;
        case ADDRESSPOPUP.OPEN_POPUP:
            return Object.assign({},state,{
                OPEN_ADDRESS_LIST: null,
                OPEN_POPUP:OPEN_POPUP,
                OPEN_POPUP_STATUS: 1
                              
            })
            break;
        case ADDRESSPOPUP.GET_POPUP_PROVINCE_PROTOTYPE:
            return Object.assign({},state,{
                GET_POPUP_PROVINCE_PROTOTYPE
            })
            break;
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./common/reducers/addressPopup.js